import { render, staticRenderFns } from "./recordDetail.vue?vue&type=template&id=ba62207a&scoped=true&"
import script from "./recordDetail.vue?vue&type=script&lang=ts&"
export * from "./recordDetail.vue?vue&type=script&lang=ts&"
import style0 from "./recordDetail.vue?vue&type=style&index=0&id=ba62207a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba62207a",
  null
  
)

export default component.exports